import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../generic-ui/Pagination";
import {
    startLoadingSuggestCasesPaginated,
    startDownloadingSuggestWord
} from "../../app/actions/suggestCaseActions";
import Select from "../generic-ui/Select";

import Swal from "sweetalert2";
import SuggestCaseViewModal from "./SuggestCaseViewModal";
import { useTranslation } from "react-i18next";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListSuggestCases = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // Selectores de Redux
    const {
        suggestCasesP = [],
        totalPagesP = 0,
        totalItemsP = 0,
        currentPageP = 0
    } = useSelector((state) => state.suggestCase || {});

    // Estados locales
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [, setCurrentPageClick] = useState(0);

    const [isDownloading, setIsDownloading] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedCase, setSelectedCase] = useState(null);

    // Carga inicial
    useEffect(() => {
        dispatch(startLoadingSuggestCasesPaginated(0, itemsPerPage));
    }, [dispatch, itemsPerPage]);

    // Abrir Modal de Visualización
    const handleViewCase = (item) => {
        setSelectedCase(item);
        setModalIsOpen(true);
    };

    // Ejecutar Descarga de Word
    const handleDownloadWord = async (id) => {
        setIsDownloading(id);
        try {
            // Disparar el Action que maneja el Blob
            dispatch(startDownloadingSuggestWord(id));
        } catch (error) {
            console.error("Error en la descarga:", error);
            Swal.fire("Error", "No se pudo generar el documento", "error");
        } finally {
            setIsDownloading(null);
        }
    };

    const onChangeSelect = (event) => {
        if (suggestCasesP && suggestCasesP.length > 0) {
            dispatch(startLoadingSuggestCasesPaginated(0, event.target.value));
        }

        setCurrentPageClick(0);
        setItemsPerPage(event.target.value);
    };

    const onPageChange = (pageClick) => {
        if (suggestCasesP && suggestCasesP.length > 0) {
            dispatch(startLoadingSuggestCasesPaginated(pageClick - 1, itemsPerPage));
        }
        setCurrentPageClick(pageClick);
    };


    return (
        <div className="container mt-4 animate__animated animate__fadeIn">

            {/* Modal para previsualizar los datos del registro */}
            <SuggestCaseViewModal
                modalIsOpen={modalIsOpen}
                closeModal={() => setModalIsOpen(false)}
                data={selectedCase}
            />

            <div className="card shadow-sm border-0">
                <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 text-primary font-weight-bold">
                        <i className="fas fa-list-alt mr-2"></i> Listado de Sugerencias
                    </h4>
                    <span className="badge badge-primary p-2">Total: {totalItemsP}</span>
                </div>

                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="border-0">ID</th>
                                    <th className="border-0">Caso / Pregunta</th>
                                    <th className="border-0">Módulo</th>
                                    <th className="border-0">Remitente</th>
                                    <th className="border-0 text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {suggestCasesP.length > 0 ? (
                                    suggestCasesP.map((item) => (
                                        <tr key={item.id} className="animate__animated animate__fadeIn">
                                            <td className="align-middle font-weight-bold">#{item.id}</td>
                                            <td className="align-middle">
                                                <div className="text-truncate" style={{ maxWidth: "300px" }} title={item.case_name || item.question_name}>
                                                    {item.case_name || item.question_name}
                                                </div>
                                            </td>
                                            <td className="align-middle">
                                                <span className="badge border border-primary text-primary text-uppercase p-2">
                                                    {item.CatalogModule_To_SuggestCase?.key ? t(`general.component-search-${item.CatalogModule_To_SuggestCase.key}`) : 'N/A'}
                                                </span>
                                            </td>
                                            <td className="align-middle">
                                                <div className="small font-weight-bold">{item.sender_name}</div>
                                                <div className="text-muted small">{item.sender_email}</div>
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group shadow-sm">
                                                    <button
                                                        className="btn btn-sm btn-outline-info"
                                                        title="Ver Detalle"
                                                        onClick={() => handleViewCase(item)}
                                                    >
                                                        <i className="fas fa-eye"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-outline-primary"
                                                        title="Descargar Word"
                                                        onClick={() => handleDownloadWord(item.id)}
                                                        disabled={isDownloading === item.id}
                                                    >
                                                        {isDownloading === item.id ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : (
                                                            <i className="fas fa-file-word"></i>
                                                        )}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-5 text-muted">
                                            <i className="fas fa-folder-open fa-3x d-block mb-2 opacity-50"></i>
                                            No se encontraron sugerencias para mostrar.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div>
                    <Select
                        listOptions={listOptions}
                        onChangeSelect={onChangeSelect}
                        pageSize={itemsPerPage}
                    />
                </div>

                <div className="card-footer bg-white d-flex justify-content-center py-3 border-top">
                    <Pagination
                        totalPages={totalPagesP}
                        totalItems={totalItemsP}
                        currentPage={currentPageP + 1}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default ListSuggestCases;
